import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControlKeyLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"control-key-left"} maskId="square-outlined-radius-0-stroke-1-IconControlKeyLeft"><path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><path d="M6.5 10L9 7.5L11.5 10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
}));

export default IconControlKeyLeft;
